import z from 'zod';
import { optionalIntegerQueryParamSchema } from './query-param';

export const paginationResponseSchema = z.object({
  page: z.int(),
  limit: z.int(),
  total: z.int(),
});

export const paginationRequestSchema = z.object({
  page: optionalIntegerQueryParamSchema.default(1),
  limit: optionalIntegerQueryParamSchema,
});

export type PaginationResponse = z.infer<typeof paginationResponseSchema>;
export type PaginationRequest = z.infer<typeof paginationRequestSchema>;
